import Ajax from 'global/od/Ajax';

export default (emailId, pageType) =>
	getData(`/ajax/${pageType}/multi/about-you/check-email-exist`, emailId);

const getData = (url, emailId) =>
	Ajax({
		url,
		method: 'POST',
		data: { emailId },
	});
